


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {Container,Grid,Card,CardContent,Typography,Box,Paper,
} from "@mui/material";

import DiagnosticSample from "../Logos/diagnostic_collection.png";
import DoctorVisitPickupDrop from "../Logos/medicine_delivery.png";
import ElderlyCare from "../Logos/Elder&childcarePage/ElderlyCare.png";
import EmergencyCareSupport from "../Logos/EmergencyCareSupport/EmergencyCareSupport.png";
import ForSeniors from "../Logos/SocialWellness/ForSeniors.png";
import PhysiotherapyatHome from "../Logos/Nursing/PhysiotherapyatHome.png";
import Footer from "../Common/Footer"
const services = [
  {
    id: "1",
    title: "ELDERLY AND CHILDCARE",
    subtitle: "Professional care for elderly and children at home",
    image: ElderlyCare,
    screen: "/elder-child-care",
    color: "#006D77",
    iconBg: "#DBEAFE",
  },
  {
    id: "2",
    title: "NURSING & PHYSIOTHERAPY SERVICES",
    subtitle: "Expert nursing and physiotherapy at your doorstep",
    image: PhysiotherapyatHome,
    screen: "/nursingPhysiotherapy",
    color: "#006D77",
    iconBg: "#DCFCE7",
  },
  {
    id: "3",
    title: "MEDICINE DELIVERY",
    subtitle: "Get your medicines delivered to your home quickly.",
    image: DoctorVisitPickupDrop,
    screen: "/medicine-order-type",
    color: "#006D77",
    iconBg: "#FDE68A",
  },
  {
    id: "4",
    title: "EMERGENCY CARE SUPPORT",
    subtitle: "24/7 emergency medical care and support",
    image: EmergencyCareSupport,
    screen: "/emergencycare",
    color: "#006D77",
    iconBg: "#FECACA",
  },
  {
    id: "5",
    title: "DOCTOR VISIT, PICKUP & DROP",
    subtitle: "Doctor home visits and transportation services",
    image: DoctorVisitPickupDrop,
    screen: "/doctor-visit",
    color: "#006D77",
    iconBg: "#E9D5FF",
  },
  {
    id: "6",
    title: "SOCIAL WELLNESS ACTIVITIES",
    subtitle: "Engaging social and wellness programs",
    image: ForSeniors,
    screen: "/social-wellness-activities",
    color: "#006D77",
    iconBg: "#D1FAE5",
  },
  {
    id: "7",
    title: "DIAGNOSTIC SAMPLE COLLECTION",
    subtitle: "We collect your diagnostic samples from your home.",
    image: DiagnosticSample,
    screen: "/medicine-diagnostic",
    color: "#006D77",
    iconBg: "#D1FAE5",
  },
];

const ServiceSelectionScreen = () => {
  const navigate = useNavigate();
  const [servicePrices, setServicePrices] = useState([]);

  useEffect(() => {
    fetchServicePrices();
  }, []);

  const fetchServicePrices = async () => {
    try {
      const res = await axios.get(process.env.REACT_APP_GET_SERVICES);
      setServicePrices(res.data);
    } catch (err) {
      console.error("Error fetching service prices:", err);
    }
  };

  const getPriceForService = (serviceName) => {
    if (!servicePrices.length) return "Loading...";
    const normalize = (str) => str.replace(/[^a-z0-9]/gi, "").toLowerCase();
    const match = servicePrices.find(
      (s) => normalize(s.name) === normalize(serviceName)
    );
    return match ? `₹${match.price.toFixed(2)}` : "";
  };

  const getSortedServices = () => {
    const activeServiceIds = ["3", "7"];
    
    const activeServices = services.filter(service => 
      activeServiceIds.includes(service.id)
    );
    const inactiveServices = services.filter(service => 
      !activeServiceIds.includes(service.id)
    );
    
    return [...activeServices, ...inactiveServices];
  };

  const handleServiceClick = (service) => {
    const activeServiceIds = ["3", "7"];
    const isActive = activeServiceIds.includes(service.id);
    
    if (!isActive) return;

    // Navigate directly to the service's screen route
    // The screen property in the services array contains the correct route
    navigate(service.screen);
  };

  const activeServiceIds = ["3", "7"];

  return (
    <>
    <Box sx={{ minHeight: "100vh", bgcolor: "#F9FAFB", pb: 4 }}>
      {/* Header */}
      <Paper
        elevation={2}
        sx={{
          bgcolor: "#fff",
          mb: 3,
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ py: 3, textAlign: "center" }}>
             <Typography variant="h4" sx={{ color: "#006D77", fontWeight: 600 }}>
              Our Services
            </Typography>
            <Typography
              sx={{
                fontSize: 18,
                color: "#22577A",
                fontWeight: 400,
              }}
            >
              Choose from our comprehensive healthcare services
            </Typography>
          </Box>
        </Container>
      </Paper>

      {/* Services Grid */}
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          {getSortedServices().map((service) => {
            const isActive = activeServiceIds.includes(service.id);

            return (
                <Grid item xs={14} sm={6} md={4} key={service.id}>
                <Card
                  elevation={3}
                  sx={{
                    bgcolor: service.color,
                    borderRadius: 4,
                    width: 350, 
                    height: 380, 
                    opacity: isActive ? 1 : 0.5,
                    cursor: isActive ? "pointer" : "default",
                    transition: "transform 0.2s, box-shadow 0.2s",
                    "&:hover": isActive
                      ? {
                          transform: "translateY(-4px)",
                          boxShadow: 6,
                        }
                      : {},
                  }}
                  onClick={() => handleServiceClick(service)}
                >
                  <CardContent sx={{ p: 0.5 }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                      }}
                    >
                      {/* Image only - no background container */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            mb: 1,
                          }}
                        >
                          <Box
                            component="img"
                            src={service.image}
                            alt={service.title}
                            sx={{
                              width: 350,
                              height: 200,
                              objectFit: "contain",
                            }}
                          />
                        </Box>

                      {/* Text Content */}
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          sx={{
                            fontSize: 17,
                            fontWeight: 900,
                            color: "#E5FDCF",
                            mb: 2,
                            lineHeight: 2.2,
                          }}
                        >
                          {service.title}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 14,
                            color: "#FFFFFF",
                            mb: 1.5,
                            lineHeight: 2.2,
                            minHeight: 36,
                          }}
                        >
                          {service.subtitle}
                        </Typography>
                        
                        {/* Price */}
                        {/* {getPriceForService(service.title) && (
                          <Typography
                            sx={{
                              fontSize: 16 ,
                              fontWeight: 600,
                              color: "#059669",
                              mb: 1,
                            }}
                          >
                            {getPriceForService(service.title)}
                          </Typography>
                        )} */}

                        {/* Action Button/Text */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: 0.5,
                            backgroundColor: isActive ? "#80ED99" : "#80ED99",
                            color: isActive ? "#22577A" : "#22577A",
                            borderRadius: "20px", // Curved borders
                            padding: "8px 16px", // Button padding
                            cursor: isActive ? "pointer" : "not-allowed",
                            border: "none",
                            width: "fit-content", 
                            transition: "all 0.3s ease",
                            "&:hover": isActive ? {
                              backgroundColor: "#B3F2C9",
                              transform: "translateY(-1px)",
                            } : {},
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: 13,
                              fontWeight: 600,
                            }}
                          >
                            {isActive
                              ? service.title === "MEDICINE DELIVERY"
                                ? "Book Medicine"
                                : "Book Service"
                              : "Book Service"}
                          </Typography>

                          {isActive && (
                            <Typography
                              sx={{
                                fontSize: 16,
                                fontWeight: "bold",
                              }}
                            >
                              →
                            </Typography>
                          )}
                        </Box>  
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
    <Footer/>
    </>
  );
};

export default ServiceSelectionScreen;